<template>
    <wrapper>
        <main class="main-content-wrapper">
            <card>
                <div class="row">
                    <div class="col-lg-3">
                        ID Servis
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Masukan ID servis"
                            v-model="searchServiceId"
                        />
                    </div>
                    <div class="col-lg-3">
                        Nama Vendor
                        <single-select-v2
                            placeholder="Masukan nama vendor"
                            :value="searchVendorName"
                            :options="serviceVendorOptions"
                            @change="searchVendorName = $event"
                            @search="onSearchVendor"
                        />
                    </div>
                    <div class="col-lg-3">
                        Tanggal Dibuat
                        <input
                            type="date"
                            class="form-control"
                            v-model="searchCreatedAt"
                        />
                    </div>
                    <div class="col-lg-3">
                        Dibuat Oleh
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Nama pembuat data"
                            v-model="searchCreatedBy"
                        />
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button
                        class="btn btn-primary default-btn"
                        :disabled="loadingSearchButton"
                        @click="searchData(1)"
                    >
                        <span v-if="loadingSearchButton">
                            <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 4px;" />
                        </span>
                        Cari
                    </button>
                    <button class="btn reset-btn default-btn ml-2" @click="resetSearch()">
                        Reset
                    </button>
                </div>
            </card>

            <div class="mt-4 d-flex align-items-center flex-wrap">
                <button class="btn btn-primary" @click="toCreateService()" v-if="allowCreateService">
                    + Buat Baru
                </button>
                <div class="status-filter-group">
                    <button
                        v-for="status in serviceStatusOptions"
                        :key="status.statusName"
                        type="button"
                        class="status-filter-btn"
                        :class="{ active: searchServiceStatus === status.value }"
                        @click="toggleStatusFilter(status.value)"
                    >
                        {{ status.statusName }}
                    </button>
                </div>
            </div>

            <div class="service-table-wrapper mt-3">
                <table class="table service-table">
                    <thead>
                        <tr>
                            <th>ID SERVIS</th>
                            <th>NAMA VENDOR</th>
                            <th>TANGGAL DIBUAT</th>
                            <th>DIBUAT OLEH</th>
                            <th>STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable === false && totalData == '0'">
                            <td colspan="5" class="text-center">Data Not Available</td>
                        </tr>
                        <tr v-else-if="loadingTable === true">
                            <td colspan="5" class="text-center">
                                <img src="~@/assets/images/load-button.gif" />
                            </td>
                        </tr>
                        <tr v-for="data in serviceList" v-else :key="`service-${data.id}`">
                            <td class="text-center">
                                <router-link :to="{ path: '/service/' + data.id, query: { code: data.serviceCode } }">
                                    {{ data.serviceCode }}
                                </router-link>
                            </td>
                            <td>{{ data.vendorName }}</td>
                            <td>{{ data.createdDate }}</td>
                            <td>{{ data.createdBy }}</td>
                            <td class="text-center">
                                <span :class="statusBadgeClass(data.statusLabel)">{{ data.statusLabel }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                    <select
                        class="form-control form-control-sm showing-select"
                        v-model="itemPerPage"
                        @change="searchData(1)"
                    >
                        <option value="10">Showing data 10</option>
                        <option value="20">Showing data 20</option>
                        <option value="50">Showing data 50</option>
                    </select>
                    <span class="total-data ml-3">Total Data {{ totalData }}</span>
                </div>
                <div class="d-flex align-items-center">
                    <button
                        class="btn btn-sm pagination-arrow-btn"
                        @click="searchData(parseInt(currentPage) - 1)"
                        :disabled="currentPage <= 1"
                    >&lt;</button>
                    <button class="btn btn-sm btn-primary pagination-page-btn mx-2">
                        Page {{ currentPage }} of {{ totalPage || 1 }}
                    </button>
                    <button
                        class="btn btn-sm pagination-arrow-btn"
                        @click="searchData(parseInt(currentPage) + 1)"
                        :disabled="currentPage >= totalPage"
                    >&gt;</button>
                </div>
            </div>
        </main>
    </wrapper>
</template>

<script>
import Swal from "sweetalert2";
import { Wrapper, Card } from '../Layout';
import { SingleSelectV2 } from '../Input';

export default {
    name: 'ServiceListPage',
    components: {
        Wrapper,
        Card,
        SingleSelectV2,
    },
    data() {
        return {
            spaceRegex: /[ ﻿ ]/g,
            allowCreateService: false,
            loadingSearchButton: false,
            loadingTable: true,
            searchServiceId: '',
            searchVendorName: '',
            searchCreatedAt: '',
            searchCreatedBy: '',
            searchServiceStatus: '',
            serviceVendorOptions: [],
            serviceStatusOptions: [
                {
                    statusName : 'Sedang Diservis',
                    value : 'in_service'
                },
                {
                    statusName : 'Selesai Sebagian',
                    value : 'partially_completed'
                },
                 {
                    statusName : 'Selesai',
                    value : 'completed'
                },
                 {
                    statusName : 'Dibatalkan',
                    value : 'cancelled'
                },
            ],
            serviceList: [],
            totalData: '0',
            totalPage: 1,
            currentPage: 1,
            itemPerPage: '10',
        };
    },
    methods: {
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            if(!this.permission.includes('27.1')) {
                this.$router.push('/');
            }
            if(this.permission.includes('27.3')) {
                this.allowCreateService = true;
            }

        },
        statusBadgeClass(status) {
            const map = {
                'sedang diservis': 'service-badge service-badge-progress',
                'selesai sebagian': 'service-badge service-badge-partial',
                'selesai': 'service-badge service-badge-done',
                'dibatalkan': 'service-badge service-badge-cancelled',
            };
            return map[(status || '').toLowerCase()] || 'service-badge service-badge-progress';
        },
        formatDateFilter(value) {
            if (!value) return '';
            const [year, month, day] = value.split('-');
            return `${day}-${month}-${year}`;
        },
        toggleStatusFilter(status) {
            this.searchServiceStatus = this.searchServiceStatus === status ? '' : status;
            this.searchData(1);
        },
        searchData(page) {
            this.$router.push({
                path: '/service',
                query: {
                    serviceId: this.searchServiceId,
                    vendorName: this.searchVendorName,
                    createdAt: this.searchCreatedAt,
                    createdBy: this.searchCreatedBy,
                    status: this.searchServiceStatus || '',
                    page: page,
                    itemPerPage: this.itemPerPage,
                },
            });
        },
        resetSearch() {
            this.searchServiceId = '';
            this.searchVendorName = '';
            this.searchCreatedAt = '';
            this.searchCreatedBy = '';
            this.searchServiceStatus = '';
            this.itemPerPage = '10';
            this.searchData(1);
        },
        toCreateService() {
            this.$router.push('/service/create');
        },
        getData() {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });

            this.loadingTable = true;
            this.searchServiceId = this.$route.query.serviceId || '';
            this.searchVendorName = this.$route.query.vendorName || '';
            this.searchCreatedAt = this.$route.query.createdAt || '';
            this.searchCreatedBy = this.$route.query.createdBy || '';
            this.searchServiceStatus = this.$route.query.status || '';
            this.currentPage = parseInt(this.$route.query.page) || 1;
            this.itemPerPage = parseInt(this.$route.query.itemPerPage || 10);

            // TODO: replace with a real call to process.env.SEARCH_SERVICE once the endpoint exists

            const searchDate = this.formatDateFilter(this.searchCreatedAt);

            this.$http.post(process.env.SERVICE_SEARCH, {
                page: this.currentPage,
                itemPerPage : this.itemPerPage,
                serviceCode : this.searchServiceId,
                createdBy : this.searchCreatedBy,
                createdDate : searchDate,
                vendorName : this.searchVendorName,
                status : this.searchServiceStatus,
            },{
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            })
            .then((response) => {
                if (response.data.status === 400) {
                    swalWithBootstrapButtons.fire({
                        title: "Failed",
                        text: `${response.data.message}`,
                        icon: "error",
                    })
                } else {
                    this.serviceList = response.data.data.data
                    this.totalData = response.data.datatotalData;
                    this.totalPage = response.data.data.totalPage;
                    this.currentPage = response.data.data.currentPage;

                }
            })
            
            this.loadingTable = false;
        },
        getVendorList(keyword = '') {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                confirmButton: "btn btn-primary ml-2",
                cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });

            this.$http.post(process.env.SERVICE_GET_VENDORS, {
                keyword : keyword
            },{
                headers: { 'Asani-Token': localStorage.getItem('jwt') },
            })
            .then((response) => {
                if(response.status !== 200 || response.data.status !== 200) {
                    swalWithBootstrapButtons.fire({
                        title: "Failed",
                        text: `${response.data.message ? response.data.message : response.message}`,
                        icon: "error",
                    })
                } else {
                    this.serviceVendorOptions = response.data.data.vendors.map((vendor) => ({
                        label: vendor,
                        value: vendor,
                    }));
                }
            })
        },
        onSearchVendor(keyword) {
            this.getVendorList(keyword);
        },
        async handleLogout() {
            try {
                await this.$http.post(process.env.LOGOUT, {}, {
                    headers: { 'Asani-Token': localStorage.getItem('jwt') },
                });
            } catch (error) {
                if (error.response.data.status !== 401) return;
            }
            localStorage.removeItem('jwt');
            localStorage.removeItem('admin_name');
            localStorage.removeItem('roles');
            localStorage.removeItem('user_email');
            localStorage.removeItem('admin_id');
            this.$router.push('/');
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/');
            }
        },
    },
    watch: { 
        $route() {
            this.getData();
        },
    },
    created() {
        this.cekLogin();
        this.getData();
        this.cekPermission()
        this.getVendorList();
    },
};
</script>

<style scoped>
.main-content-wrapper {
    padding: 24px;
}

.status-filter-group {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-left: auto;
}

.status-filter-btn {
    border: 1px solid #dee2e6;
    background: #fff;
    color: #495057;
    border-radius: 20px;
    padding: 6px 18px;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.status-filter-btn:hover {
    background-color: #f8f9fa;
}

.status-filter-btn.active {
    background-color: #e7f1ff;
    border-color: #4285f4;
    color: #1a56db;
    font-weight: 600;
}

.service-table-wrapper {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    overflow: hidden;
}

.service-table {
    margin-bottom: 0;
}

.service-table thead th {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    background-color: #f8f9fa;
    border-top: none;
    border-bottom: 1.5px solid #e9ecef;
    border-right: 1.5px solid #e9ecef;
    padding: 14px 16px;
    white-space: nowrap;
}

.service-table thead th:last-child {
    border-right: none;
}

.service-table tbody td {
    vertical-align: middle;
    font-size: 13px;
    color: #343a40;
    padding: 14px 16px;
    border-top: none;
    border-bottom: 1.5px solid #f1f3f5;
    border-right: 1.5px solid #f1f3f5;
}

.service-table tbody td:last-child {
    border-right: none;
}

.service-table tbody tr:last-child td {
    border-bottom: none;
}

.service-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid transparent;
}

.service-badge-progress {
    color: #c98a06;
    background: #fff6e0;
    border-color: #f5e2ad;
}

.service-badge-partial {
    color: #0d6efd;
    background: #e7f1ff;
    border-color: #b6d4fe;
}

.service-badge-done {
    color: #28a745;
    background: #e8f8ee;
    border-color: #c3ecd2;
}

.service-badge-cancelled {
    color: #6c757d;
    background: #eef1f4;
    border-color: #dfe4e8;
}

.showing-select {
    width: auto;
    min-width: 140px;
}

.total-data {
    font-size: 14px;
    color: #343a40;
    white-space: nowrap;
}

.pagination-arrow-btn {
    border: 1px solid #dee2e6;
    background: #fff;
    color: #343a40;
    min-width: 32px;
}

.pagination-arrow-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-page-btn {
    min-width: 110px;
}

.default-btn {
    min-width: 80px;
}

.reset-btn {
    border: 1px solid #dee2e6;
    background: #fff;
    color: #343a40;
}

.reset-btn:hover {
    background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Service/ServiceListPage.vue